import axios from "axios";
import { refreshAccessToken } from "../repository/refreshAccessToken";
import { BASE_URL } from "../config/Config";
 
const getAuthHeader = () => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const token = auth?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch (error) {
    console.error("Error retrieving token from localStorage", error);
    return {};
  }
};
 
const apiService = (path = "") => {
  const instance = axios.create({
    baseURL: `${BASE_URL}/${path}`,
    headers: getAuthHeader(),
  });
 
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
 
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
 
        try {
          const auth = JSON.parse(localStorage.getItem("auth"));
          const newTokens = await refreshAccessToken(auth?.refresh_token);
 
          if (newTokens?.access_token) {
            localStorage.setItem("auth", JSON.stringify(newTokens));
            originalRequest.headers.Authorization = `Bearer ${newTokens.access_token}`;
            return instance(originalRequest);
          }
        } catch (refreshError) {
          console.error("Refresh token failed", refreshError);
        }
      }
 
      return Promise.reject(error);
    }
  );
 
  return {
    get: async (endpoint) => (await instance.get(endpoint)).data,
    post: async (endpoint, data) => (await instance.post(endpoint, data)).data,
    put: async (endpoint, data) => (await instance.put(endpoint, data)).data,
    patch: async (endpoint, data) =>
      (await instance.patch(endpoint, data)).data,
    delete: async (endpoint) => (await instance.delete(endpoint)).data,
  };
};
 
export default apiService;
 